import { render, staticRenderFns } from "./joinDetail.vue?vue&type=template&id=38d4f4a0&scoped=true&"
import script from "./joinDetail.vue?vue&type=script&lang=js&"
export * from "./joinDetail.vue?vue&type=script&lang=js&"
import style0 from "./joinDetail.vue?vue&type=style&index=0&id=38d4f4a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4f4a0",
  null
  
)

export default component.exports